import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61c624d4")

_pushScopeId("data-v-61c624d4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Nuovo movimento")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "container_prenotazioni" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "selection_title" }, "Magazzino", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "selection_title" }, "Tipo movimento", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Carico")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Scarico")
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "selection_title" }, "Causale", -1)
const _hoisted_10 = { style: {"margin-top":"24px"} }
const _hoisted_11 = { class: "last_barcode" }
const _hoisted_12 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_StreamBarcodeReader = _resolveComponent("StreamBarcodeReader")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.arrowBackOutline,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", null, [
                    _hoisted_5,
                    _createVNode(_component_ion_select, {
                      name: "tipologia",
                      interface: "action-sheet",
                      "cancel-text": "Annulla",
                      "ok-text": "Conferma",
                      modelValue: _ctx.selectedMagazzino,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedMagazzino = $event)),
                      value: "1",
                      placeholder: "Seleziona magazzino",
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectedMagazzino($event.target.value)))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.magazzini, (magazzino) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: magazzino.magazzini_id,
                            value: magazzino.magazzini_id
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(magazzino.magazzini_titolo), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", null, [
                    _hoisted_6,
                    _createVNode(_component_ion_select, {
                      name: "tipologia",
                      interface: "action-sheet",
                      "cancel-text": "Annulla",
                      "ok-text": "Conferma",
                      modelValue: _ctx.selectedMovimento,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedMovimento = $event)),
                      value: "1",
                      placeholder: "Seleziona movimento",
                      onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSelectedMovimento($event.target.value)))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_select_option, { value: "1" }, {
                          default: _withId(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "2" }, {
                          default: _withId(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", null, [
                    _hoisted_9,
                    _createVNode(_component_ion_select, {
                      name: "tipologia",
                      interface: "action-sheet",
                      "cancel-text": "Annulla",
                      "ok-text": "Conferma",
                      modelValue: _ctx.selectedCausale,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedCausale = $event)),
                      value: "1",
                      placeholder: "Seleziona causale",
                      onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSelectedCausale($event.target.value)))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.causali, (causale) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: causale.movimenti_causali_id,
                            value: causale.movimenti_causali_id
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(causale.movimenti_causali_nome), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("button", {
                      class: "prenotazione_button",
                      style: {"margin-bottom":"24px"},
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reloadScanning && _ctx.reloadScanning(...args)))
                    }, "Riprendi scansione"),
                    _createVNode("button", {
                      class: "nuovo_movimento_button",
                      style: {"margin-bottom":"24px"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.creaMovimento && _ctx.creaMovimento(...args))),
                      disabled: _ctx.disableNewMovimento
                    }, " Crea movimento ", 8, ["disabled"]),
                    _createVNode(_component_StreamBarcodeReader, {
                      ref: "scannerRef",
                      onDecode: _ctx.onDecode,
                      onLoaded: _ctx.onLoaded
                    }, null, 8, ["onDecode", "onLoaded"]),
                    _createVNode("div", _hoisted_11, "Barcode rilevato: " + _toDisplayString(_ctx.decodedText ? _ctx.decodedText : "-"), 1),
                    (_ctx.products && _ctx.products.length != 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (prod, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: index,
                              class: "single_product"
                            }, [
                              _createVNode("span", null, _toDisplayString(prod.name), 1),
                              _createVNode("span", null, _toDisplayString(prod.barcode), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})